import { render, staticRenderFns } from "./applyMy.vue?vue&type=template&id=5c50f8fa&scoped=true&"
import script from "./applyMy.vue?vue&type=script&lang=js&"
export * from "./applyMy.vue?vue&type=script&lang=js&"
import style0 from "./applyMy.vue?vue&type=style&index=0&id=5c50f8fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50f8fa",
  null
  
)

export default component.exports